/** The org admin's powers over the organization's own configuration
 *  (#10718 slice 5): the org's admin, whose org permission entry carries
 *  `admin: true` (a staff member's collaborator holds it after the grant's
 *  admin elevation). Mirrors the backend's `administers_org()`; the staff
 *  bit plays no part. */
// `any` because callers hand in the untyped redux `userData` slice.
export const userCanAdministerOrg = (user: any): boolean =>
  (user?.permissions ?? []).some(
    (permission: any) =>
      permission?.organizationId != null && permission?.admin === true
  );

/** Whether the organization the user acts in gives them `product`: its
 *  org-wide products and the user's own grants, as the backend's
 *  `allowed_products_for_user` lists them on the signed-in user. A feature
 *  preview is a product granted to chosen users (#10718), never the staff
 *  bit. */
export const userHasProduct = (user: any, product: string): boolean =>
  ((user?.organization?.allowed_products ?? []) as string[]).includes(product);

/** Whether the user may write in the organization they act in: its org
 *  permission entry carries `write` or `admin`, or is a pre-roles entry with
 *  neither flag, which every admin control already treats as unrestricted.
 *  The server still checks each file's own access. */
export const userCanWriteInOrg = (user: any): boolean => {
  const entry = (user?.permissions ?? []).find(
    (permission: any) => permission?.organizationId != null
  );
  if (!entry) return false;
  if (entry.write === true || entry.admin === true) return true;
  return entry.write === undefined && entry.admin === undefined;
};
